(function(window, document, $, undefined) {
    'use strict'

    if (typeof $ === undefined) {
        throw new Error('jQuery seems to be missing...')
    }

    $(function() {
        var $submit = $('#js__rsvp--submit')

        // @note: disable submit button in rsvp booking forms
        $(document).on('submit', 'section.booking-form form', function(e) {
            $submit
                .attr('disabled', 'disabled')
                .html('<i class="icon-submit-arrow-right icon-sm"></i>Please wait&hellip;')
        })

        // @note: stop videos playing when accordeon item closed
        $('.accordion__item input[type=checkbox]').on('change', function() {
            if ($(this).prop('checked') === false) {
                var $iframe = $(this).parent().find('iframe')

                if ($iframe.length) {
                    var src = $iframe.attr('src')

                    $iframe.attr('src', '').attr('src', src)
                }
            }
        })

        // Prevents unexpected menu close when clicking in the dropdown
        // ------------------------------------
        $(document).on('click', '.yamm .dropdown-menu', function(e) {
            e.stopPropagation()
        })

        // Show site-overlay on dropdown collapse
        // ------------------------------------
        var $body = $('body')

        $('.nav-primary .dropdown')
            .on('show.bs.dropdown', function() {
                $body.toggleClass('nav-open', true)
                if (!Modernizr.touchevents) {
                    // var $inner = $(this).find('.dropdown-menu-inner');
                    // $inner.find('[class^="col-"]').css({ height: $inner.outerHeight() });
                }
            })
            .on('hide.bs.dropdown', function() {
                if (!Modernizr.touchevents) {
                    $body.toggleClass('nav-open', false)
                }
            })

        $('.nav-primary a.level-1').on('click', function(e) {
            e.preventDefault();
            // if ($(e.target).data('clickable') == '1') {
            //     window.location = $(e.target).attr('href');
            // }
        });

        $('.site-overlay').click(function() {
            $body.removeClass('nav-open')
            $('.navbar-collapse').collapse('hide')
        })

        $('.navbar-collapse')
            .on('show.bs.collapse', function() {
                $body.toggleClass('nav-open', true)
            })
            .on('hide.bs.collapse', function() {
                $body.toggleClass('nav-open', false)
            })

        /*
        $('.nav-secondary .dropdown-fw').each(function() {
            $(this).css({
                width: $(this).parents('ul').width()
            });
        });
        */

        $('.nav-secondary .dropdown-fw.dropdown-instance-navigation').css({
            width: '282px',
            left: '-80px',
        })

        // Expands the dropdown-menu across the full width of the page
        // ------------------------------------
        var innerMenuWidthFix = function(windowWidth) {
            $('.dropdown-menu:has(.dropdown-menu-inner)').each(function() {
                var $el = $(this),
                    elementWidth = $el.data('w'),
                    offset

                // On first call, save a reference to the original width
                if (!elementWidth) {
                    elementWidth = $el.width()
                    $el.data('w', elementWidth)
                } else {
                    elementWidth = $el.data('w')
                }

                // calculate and apply the required offset
                offset = (windowWidth - elementWidth) / 2
                $el.css({ left: -offset, right: -offset })
            })
        }

        $(window).on(
            'resize',
            $.debounce(250, function() {
                innerMenuWidthFix($(this).width())
            })
        )

        innerMenuWidthFix($(window).width())

        // Home Modal
        // ------------------------------------
        var $emailSignupBtn = $('#emailSignupBannerButton'),
            $emailSignupModal = $($emailSignupBtn.data('modal-target')),
            $emailSignupForm = $($emailSignupBtn.data('scroll-target'))

        if ($emailSignupBtn.length > 0) {
            $emailSignupBtn.on('click', function(e) {
                e.preventDefault()

                if (Modernizr.touchevents) {
                    $('html, body').animate({
                            scrollTop: $emailSignupForm.offset().top,
                        },
                        500
                    )
                } else {
                    $emailSignupModal.modal('show')
                }
            })
        }

        // Textarea Expander
        // ------------------------------------

        $('.textarea-expand').each(function() {
            var $el = $(this),
                $helper = $(document.createElement('div')),
                content = null

            $helper.addClass('textarea-expand-helper')
            $('body').append($helper)

            $el.on('keyup', function() {
                content = $el.val()
                content = content.replace(/\n/g, '<br>')
                $helper.html(content + '<br class="lbr">')
                $(this).css('height', $helper.height())
            })
        })

        // Blog
        // ------------------------------------

        var $subscribeBtn = $('#subscribeBannerButton'),
            $subscribeModal = $($subscribeBtn.data('modal-target')),
            $subscribeForm = $($subscribeBtn.data('scroll-target'))

        if ($subscribeBtn.length > 0) {
            $subscribeBtn.on('click', function(e) {
                e.preventDefault()

                if (Modernizr.touchevents) {
                    $('html, body').animate({
                            scrollTop: $subscribeForm.offset().top,
                        },
                        500
                    )
                } else {
                    $subscribeModal.modal('show')
                }
            })
        }

        // Triple P Selector
        // ------------------------------------

        // @note this should be put in a self containing function
        // @note: old way: touchEnabled: (navigator.maxTouchPoints > 0)

        var $tpsContainer = $('.triple-p-selector'),
            tpsSliderInstance

        // Triple P Slider logic
        function initTpsSlider(scope) {
            var $tpsSliderEl = $('.triple-p-selector-slider')

            if ($tpsSliderEl.length > 0) {
                tpsSliderInstance = $tpsSliderEl.bxSlider({
                    pager: false,
                    controls: false,
                    infiniteLoop: false,
                    touchEnabled: false,
                })
            }
        }

        // Blog Options
        // ------------------------------------
        $(document).on('click', '.blog-option-content a', function(e) {
            e.preventDefault()
            $(e.currentTarget).toggleClass('active').trigger('blur')
        })

        $(document).on('click', '.blog-btn-clear-filters', function(e) {
            e.preventDefault()
            $('.blog-option-content a').toggleClass('active', false)
        })

        // CTA Tool, Double Version - tab logic
        $(document).on('click', '.multi-cta-tool-tabs a', function(e) {
            e.preventDefault()
            $(this).tab('show')
        })

        // This toggler is used on the mobile version of landingpage Top Tips School Life during COVID-19
        $(document).on('click', '.js-read-more', function(e) {
            var $more = $(this)
            var $toggler = $(this).next()
            var $less = $toggler.next()

            e.preventDefault()

            $more.fadeOut()
            $toggler.fadeIn()
            $less.fadeIn()
        })

        $(document).on('click', '.js-read-less', function(e) {
            var $less = $(this)
            var $toggler = $(this).prev()
            var $more = $toggler.prev()

            e.preventDefault()

            $more.fadeIn()
            $toggler.fadeOut()
            $less.fadeOut()
        })

        // Save ui dialogs with ⌘ + Enter
        $(document).on('keydown', '#ccm-block-form', function(e) {
            if (e.metaKey && e.key === 'Enter') {
                $('#ccm-block-form').submit()
            }
        })

        $(document).on('keydown', 'body', function(e) {
            if (e.metaKey && e.altKey && e.key === 'Enter') {
                var $publish = $('#ccm-check-in-publish')
                if ($publish.length > 0) {
                    $publish.trigger('click')
                }
            }
        })

        $(document).on('dialogopen', '.ui-dialog.ui-widget', function(e, ui) {
            window.setTimeout(function() {
                var $fields = $('#ccm-block-form').find('input[type=text], textarea')
                if ($fields.length > 0) {
                    $fields.first().focus().select()
                }
            }, 700)
        })
    })
})(window, document, window.jQuery)
